import { ListItem } from '@chakra-ui/react';
import { List } from '@chakra-ui/react';

import { trackEvent } from '~/features/analytics/track-event';
import { ProgramCatalogCard } from '~/features/catalog/components/catalog-card-program';
import { CatalogItem } from '~/features/catalog/models/catalog-item';

export function ProgramList({ programs }: { programs: CatalogItem[] }) {
  return (
    <List
      display='flex'
      gap={2}
      justifyContent='center'
      flexDirection={{
        base: 'column',
        md: 'row',
      }}
    >
      {programs.map((program) => (
        <ListItem key={program.key} flex='0 1 268px'>
          <ProgramCatalogCard
            catalogItem={program}
            onClick={() =>
              trackEvent({
                type: 'click',
                name: 'Microsoft AI Skills Fest CTA Clicked',
                label: 'program_card_clicked',
                value: program.title ?? undefined,
                additionalAttributes: {
                  product_ids: [program.key],
                },
              })
            }
          />
        </ListItem>
      ))}
    </List>
  );
}
